<section class="product-details-skeleton">
  <!-- product preview -->
  <div class="product-details-skeleton__preview-right">
    <!-- product options -->
    <ngx-skeleton-loader
      count="4"
      [theme]="{
        height: '3.6em',
        width: '5em',
        display: 'flex',
        flexDirection: 'column',
        gap: '2.25em'
      }"></ngx-skeleton-loader>

    <!-- product main image -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '17.688em',
        width: '22.313em',
        display: 'flex',
        flexDirection: 'column',
        gap: '1.25em'
      }"></ngx-skeleton-loader>

    <div class="product-details-skeleton__preview-left">
      <!-- product title & verification -->
      <div class="w-full flex justify-between">
        <pwj-card-property-skeleton></pwj-card-property-skeleton>
        <ngx-skeleton-loader
          count="1"
          [theme]="{
            height: '2.875em',
            width: '3.75em',
            display: 'flex',
            flexDirection: 'column',
            gap: '1.25em'
          }"></ngx-skeleton-loader>
      </div>

      <!-- product description -->
      <ngx-skeleton-loader
        count="4"
        appearance="line"
        [theme]="{
          height: '0.625em',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.25em'
        }"></ngx-skeleton-loader>

      <!-- product properties -->
      <pwj-card-property-skeleton
        [count]="4"
        containerClasses="flex gap-20"></pwj-card-property-skeleton>

      <div class="flex justify-between items-center">
        <!-- product price -->
        <div class="flex flex-col gap-2">
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{
              width: '1.938em',
              height: '0.625em'
            }"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            appearance="line"
            [theme]="{
              width: '5.563em',
              height: '0.625em',
              'margin-top': '-1em'
            }"></ngx-skeleton-loader>
        </div>

        <!-- product buttons -->
        <ngx-skeleton-loader
          count="2"
          class="flex gap-30"
          [theme]="{
            width: '6.313em',
            height: '2em',
            'border-radius': '0.625em'
          }"></ngx-skeleton-loader>
      </div>
    </div>
  </div>

  <!-- product tags -->
  <div class="product-details-skeleton__tags">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '4em',
        'border-radius': '0.625em'
      }"></ngx-skeleton-loader>
  </div>
  <!-- product tabs -->
  <div class="product-details-skeleton__tabs">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '4em',
        'border-radius': '0.625em'
      }"></ngx-skeleton-loader>
  </div>
  <!-- product descriptions -->
  <div class="product-details-skeleton__descriptions">
    <!-- description label -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '1.875em',
        width: '4.75em'
      }"></ngx-skeleton-loader>
    <!-- product description -->
    <ngx-skeleton-loader
      count="4"
      appearance="line"
      [theme]="{
        height: '0.625em',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25em'
      }"></ngx-skeleton-loader>
  </div>
  <!-- product video -->
  <div class="product-details-skeleton__video">
    <!-- video label -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '1.875em',
        width: '4.75em'
      }"></ngx-skeleton-loader>
    <!-- video player -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '25em'
      }"></ngx-skeleton-loader>
  </div>

  <!-- product climatic effects -->
  <div class="product-details-skeleton__video">
    <!-- climatic effects label -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '1.875em',
        width: '8.75em'
      }"></ngx-skeleton-loader>
    <!-- climatic effects box -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '13em',
        'border-radius': '1em'
      }"></ngx-skeleton-loader>
  </div>

  <!-- product additional specifications -->
  <div class="product-details-skeleton__additional-specification">
    <!-- climatic effects label -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '1.875em',
        width: '8.75em'
      }"></ngx-skeleton-loader>
    <!-- climatic effects box -->
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '13em',
        'border-radius': '1em'
      }"></ngx-skeleton-loader>
  </div>

  <!-- other sections -->
  <div>
    <ngx-skeleton-loader
      count="8"
      appearance="line"
      class="flex flex-col gap-20"
      [theme]="{
        height: '5em'
      }"></ngx-skeleton-loader>
  </div>
</section>
